// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"PaymentCreditsSection_applyButton__jWfTo","buttonsWrapper":"PaymentCreditsSection_buttonsWrapper__22y6G","deleteButton":"PaymentCreditsSection_deleteButton__32s6v"};